module.exports = __webpack_public_path__ + "static/media/summit-event-official-logo.0f3b2fb2.svg";